<template>
  <div class="container mt-4">
    <h2>Cadastro de Empresa</h2>

    <b-form>
      <b-row>
        <b-col cols="4">
          <b-form-group label-for="invoiceNFe" label="Cliente">
            <b-form-checkbox
              v-model="entity.isPurchaser"
              id="invoiceNFe"
              switch
            >
            </b-form-checkbox>
          </b-form-group>
        </b-col>

        <b-col cols="4">
          <b-form-group label-for="invoiceNFsE" label="Fornecedor">
            <b-form-checkbox
              v-model="entity.isSupplier"
              id="invoiceNFsE"
              switch
            >
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="2">
          <b-form-group label-for="entityType" label="Tipo pessoa">
            <b-form-select
              v-model="entity.entityType"
              :options="entityTypeOptions"
              id="entityType"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col cols="4">
          <b-form-group
            label-for="documentNumber"
            :label="
              entity.entityType == '1'
                ? 'CPF'
                : entity.entityType == '2'
                ? 'Documento'
                : 'CNPJ'
            "
          >
            <b-form-input
              v-model="entity.documentNumber"
              type="text"
              id="documentNumber"
              :state="documentNumberError == false && this.entity.documentNumber != ''"
              @blur="validateDocumentNumber"
              v-mask="
                entity.entityType == '1'
                  ? '999.999.999-99'
                  : entity.entityType == '2'
                  ? '99999999999999999999'
                  : '99.999.999/9999-99'
              "
              :placeholder="
                entity.entityType == '1'
                  ? '000.000.000-00'
                  : entity.entityType == '2'
                  ? 'Digite o documento'
                  : '00.000.000/0000-00'
              "
            ></b-form-input>
            <b-form-invalid-feedback v-if="documentNumberError">
              {{ entity.entityType == "1" ? "CPF" : "CNPJ" }} inválido.
              Verifique o número digitado.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col cols="6" v-if="entity.entityType == '0'">
          <b-form-group
            label-for="fantasyName"
            :label="
              isLoadingCnpj ? 'Buscando Nome Fantasia...' : 'Nome Fantasia'
            "
          >
            <b-form-input
              v-model="entity.fantasyName"
              type="text"
              :state="
                entity.fantasyName != null &&
                  entity.fantasyName.trim().length > 0
              "
              id="fantasyName"
              placeholder="Informe o nome fantasia"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group label-for="responsibleName" label="Nome do responsável">
            <b-form-input
              v-model="entity.responsibleName"
              type="text"
              :state="
                entity.responsibleName != null &&
                  entity.responsibleName.trim().length > 0
              "
              id="responsibleName"
              placeholder="Informe o nome do responsável"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row v-if="entity.entityType == '0'">
        <b-col>
          <b-form-group
            label-for="companyName"
            :label="isLoadingCnpj ? 'Buscando Razão Social...' : 'Razão Social'"
          >
            <b-form-input
              v-model="entity.companyName"
              :state="
                entity.companyName != null &&
                  entity.companyName.trim().length > 0
              "
              type="text"
              id="companyName"
              placeholder="Informe a razão social"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6" v-if="entity.entityType == '0'">
          <b-form-group
            label-for="companyType"
            :label="
              isLoadingCnpj ? 'Buscando Tipo da empresa...' : 'Tipo Empresa'
            "
          >
            <b-form-select
              v-model="entity.companyType"
              :state="entity.companyType != null"
              :options="companyTypeOptions"
              id="entityType"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <transition name="fade">
          <b-col cols="6" v-if="entity.companyType == '2'">
            <b-form-group label-for="parentDocumentNumber" label="CNPJ Matriz">
              <b-form-input
                v-model="entity.parentDocumentNumber"
                type="text"
                id="parentDocumentNumber"
                placeholder="Informe o CNPJ Matriz"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </transition>
      </b-row>

      <b-row v-if="entity.entityType == '0'">
        <b-col cols="6">
          <b-form-group label-for="taxRegime" label="Regime Tributário">
            <b-form-select
              v-model="entity.taxRegime"
              :options="taxRegimeOptions"
              id="taxRegime"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
            label-for="specialTaxRegime"
            label="Regime Tributário Especial"
          >
            <b-form-select
              v-model="entity.specialTaxRegime"
              :options="specialTaxRegimeOptions"
              id="specialTaxRegime"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row v-if="entity.entityType == '0'">
        <b-col>
          <b-form-group
            label-for="stateRegistrationIndicator"
            label="Indicador de Incrição estadual"
          >
            <b-form-select
              v-model="entity.stateRegistrationIndicator"
              :options="stateRegistrationIndicatorOptions"
              id="stateRegistrationIndicatorOptions"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group
            label-for="stateRegistration"
            label="Inscrição estadual"
          >
            <b-form-input
              v-model="entity.stateRegistration"
              type="text"
              id="stateRegistration"
              placeholder="Informe a inscrição estadual"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group
            label-for="municipalRegistration"
            label="Inscrição municipal"
          >
            <b-form-input
              v-model="entity.municipalRegistration"
              type="text"
              id="municipalRegistration"
              placeholder="Informe a inscrição municipal"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group
            label-for="suframaRegistration"
            label="Inscrição suframa"
          >
            <b-form-input
              v-model="entity.suframaRegistration"
              type="text"
              id="suframaRegistration"
              placeholder="Informe a inscrição do SUFRAMA"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row v-if="entity.personType != '3'">
        <b-col cols="4">
          <b-form-group label-for="invoiceNFe" label="NF-E">
            <b-form-checkbox v-model="entity.invoiceNFe" id="invoiceNFe" switch>
            </b-form-checkbox>
          </b-form-group>
        </b-col>

        <b-col cols="4">
          <b-form-group label-for="invoiceNFsE" label="NFs-E">
            <b-form-checkbox
              v-model="entity.invoiceNFsE"
              id="invoiceNFsE"
              switch
            >
            </b-form-checkbox>
          </b-form-group>
        </b-col>

        <b-col cols="4">
          <b-form-group label-for="invoiceNFcE" label="NFc-E">
            <b-form-checkbox
              v-model="entity.invoiceNFcE"
              id="invoiceNFcE"
              switch
            >
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <hr />
      <h3>Endereço</h3>

      <b-row>
        <b-col>
          <b-form-group label-for="zipCode" label="CEP">
            <b-form-input
              v-model="entity.address.cep"
              type="text"
              @blur="getAddressByZipCode"
              :state="
                entity.address.cep != null &&
                  entity.address.cep.trim().length > 0
              "
              id="zipCode"
              v-mask="'99999-999'"
              placeholder="Informe o CEP"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group
            label-for="countryId"
            :label="isLoadingCountry ? 'Carregando países...' : 'Pais'"
          >
            <b-form-select
              v-model="entity.address.paisId"
              id="countryId"
              @change="getAllStates(entity.address.paisId)"
              :state="!!entity.address.paisId"
              :options="countryOptions"
              :disabled="!entity.address.cep || isLoadingCountry"
            >
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group
            label-for="state"
            :label="isLoadingState ? 'Carregando estados...' : 'Estado'"
          >
            <b-form-select
              v-model="entity.address.estadoId"
              @change="getAllCities(entity.address.estadoId)"
              id="state"
              :state="!!entity.address.estadoId"
              :options="stateOptions"
              :disabled="!entity.address.paisId || isLoadingState"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group
            label-for="city"
            :label="isLoadingCity ? 'Carregando municipios...' : 'Municipio'"
          >
            <b-form-select
              v-model="entity.address.municipioId"
              @change="getAllDistrict(entity.address.municipioId)"
              :state="!!entity.address.municipioId"
              id="city"
              :options="cityOptions"
              :disabled="!entity.address.estadoId || isLoadingCity"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group
            label-for="district"
            :label="isLoadingDistrict ? 'Carregando bairros...' : 'Bairro'"
          >
            <b-input-group>
              <b-form-select
                v-model="entity.address.bairroId"
                id="district"
                :options="districtOptions"
                @change="getAllStreets(entity.address.bairroId)"
                :state="!!entity.address.bairroId"
                :disabled="!entity.address.municipioId || isLoadingDistrict"
              ></b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col v-if="entity.address.bairroId == 'other'">
          <b-form-group label-for="district" label="Novo Bairro">
            <b-form-input
              v-model="newDistrict"
              type="text"
              id="newDistrict"
              placeholder="Informe o bairro"
            />
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group
            label-for="streetName"
            :label="
              isLoadingStreet ? 'Carregando logradouros...' : 'Logradouro'
            "
          >
            <b-form-select
              v-model="entity.address.logradouroId"
              id="streetName"
              :options="streetOptions"
              :state="!!entity.address.logradouroId"
              :disabled="!entity.address.bairroId || isLoadingStreet"
              @change="verifyNewDistrict()"
              placeholder="Informe o Logradouro"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col v-if="entity.address.logradouroId == 'other'">
          <b-form-group label-for="district" label="Novo Logradouro">
            <b-form-input
              v-model="newStreet"
              type="text"
              id="newStreet"
              placeholder="Informe o logradouro"
            />
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label-for="streetType" label="Tipo Logradouro">
            <b-form-select
              v-model="entity.address.tipoLogradouroId"
              id="streetType"
              :state="!!entity.address.tipoLogradouroId"
              :options="streetTypeOptions"
              @change="handleStreetTypeChange"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label-for="number" label="Número">
            <b-form-input
              v-model="entity.address.numero"
              id="number"
              :state="
                entity.address.numero != null &&
                  entity.address.numero.trim().length > 0
              "
              type="text"
              placeholder="Informe o Número"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <hr />
      <h3>Contato</h3>

      <b-row>
        <b-col cols="4">
          <b-form-group
            label-for="commercialPhone"
            :label="
              isLoadingCnpj ? 'Buscando Telefone...' : 'Telefone Comercial'
            "
          >
            <b-form-input
              v-model="entity.commercialPhone"
              type="text"
              id="commercialPhone"
              placeholder="Informe o Telefone Comercial"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="4">
          <b-form-group
            label-for="mobilePhone"
            :label="isLoadingCnpj ? 'Buscando Telefone...' : 'Telefone Celular'"
          >
            <b-form-input
              v-model="entity.mobilePhone"
              type="text"
              id="mobilePhone"
              placeholder="Informe o Telefone Celular"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="4">
          <b-form-group
            label-for="email"
            :label="isLoadingCnpj ? 'Buscando E-Mail...' : 'E-mail'"
          >
            <b-form-input
              v-model="entity.email"
              type="email"
              id="email"
              placeholder="Informe o E-mail"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-button variant="primary" @click="createNewEntity">Salvar</b-button>

      <fade-alert-danger
        ref="fadeAlertDanger"
        :msg="alert.error"
      ></fade-alert-danger>
      <success-fade-alert
        ref="successFadeAlert"
        :msg="alert.success"
      ></success-fade-alert>
    </b-form>
  </div>
</template>

<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
import AwesomeMask from "awesome-mask";

export default {
  name: "entityCrud",
  components: {
    FadeAlertDanger,
    SuccessFadeAlert
  },
  directives: {
    mask: AwesomeMask
  },
  data() {
    return {
      alert: {
        error: "Verifique os dados informados",
        success: "Empresa cadastrada com sucesso!"
      },
      rowData: null,
      entity: {
        id: null,
        active: true,
        companyId: null,
        company: null,
        createdAt: new Date().toISOString(),
        createdBy: null,
        createdByUser: null,
        updatedAt: new Date().toISOString(),
        updatedBy: null,
        updatedByUser: null,
        documentNumber: "",
        companyName: "",
        fantasyName: "",
        responsibleName: "",
        companyType: null,
        parentDocumentNumber: "",
        taxRegime: null,
        specialTaxRegime: null,
        entityType: 0,
        stateRegistrationIndicator: null,
        stateRegistration: null,
        municipalRegistration: "",
        suframaRegistration: "",
        cityId: null,
        city: null,
        addressId: null,
        address: {
          id: null,
          logradouroId: null,
          tipoLogradouroId: null,
          bairroId: null,
          municipioId: null,
          regiaoEstadoId: null,
          estadoId: null,
          regiaoPaisId: null,
          paisId: null,
          cep: "",
          numero: null,
          complemento: ""
        },
        isInternalGasStation: false,
        isExternalGasStation: false,
        isPurchaser: true,
        isSupplier: false,
        isCustomer: true,
        invoiceNFe: false,
        invoiceNFsE: false,
        invoiceNFcE: false,
        email: "",
        commercialPhone: "",
        mobilePhone: ""
      },
      viaCepResponse: {},
      personType: 2,
      entityTypeOptions: [
        { value: 0, text: "Jurídica" },
        { value: 1, text: "Física" },
        { value: 2, text: "Estrangeira" }
      ],
      companyTypeOptions: [
        { value: 1, text: "Matriz" },
        { value: 2, text: "Filial" }
      ],
      taxRegimeOptions: [
        { value: 0, text: "Simples Nacional" },
        { value: 1, text: "Lucro Presumido" },
        { value: 2, text: "Lucro Real" },
        { value: 3, text: "MEI" }
      ],
      specialTaxRegimeOptions: [
        { value: 0, text: "Sem Regime Tributário Especial" },
        { value: 1, text: "Micro Empresa Municipal" },
        { value: 2, text: "Estimativa" },
        { value: 3, text: "Sociedade de Profissionais" },
        { value: 4, text: "Cooperativa" },
        { value: 5, text: "Microempresa ou Pequeno Porte - ME EPP" },
        { value: 6, text: "Empresa de Responsabilidade Limitada" }
      ],
      stateRegistrationIndicatorOptions: [
        { value: 0, text: "Não contribuinte" },
        { value: 1, text: "Contribuinte" },
        { value: 2, text: "Contribuinte isento" }
      ],
      rules: {},
      countryOptions: [],
      stateOptions: [],
      cityOptions: [],
      districtOptions: [],
      newDistrict: "",
      streetOptions: [{ text: "Outro", value: "other" }],
      newStreet: "",
      streetTypeOptions: [],
      isLoadingCnpj: false,
      isLoadingCountry: false,
      isLoadingState: false,
      isLoadingCity: false,
      isLoadingDistrict: false,
      isLoadingStreet: false,
      documentNumberError: false
    };
  },
  async created() {
    if (this.$route.params.rowData)
      this.entity = JSON.parse(this.$route.params.rowData);

    this.getAllCountries();
    if (this.entity.address.paisId) {
      await this.getAllStates(this.entity.address.paisId);
      this.getAllCities(this.entity.address.estadoId);
      this.getAllDistrict(this.entity.address.municipioId);
      this.getAllStreets(this.entity.address.bairroId);
    }
    this.getAllStreetTypes();
  },
  watch: {
    "entity.isPurchaser"(newVal) {
      if (!newVal && !this.entity.isSupplier) {
        this.entity.isSupplier = true;
      }
    },
    "entity.isSupplier"(newVal) {
      if (!newVal && !this.entity.isPurchaser) {
        this.entity.isPurchaser = true;
      }
    },
    "entity.address.cep"(newCep) {
      const cep = newCep?.replace(/\D/g, "");
      if (cep?.length === 8) {
        this.getAddressByZipCode(cep);
      }
    }
  },
  methods: {
    createNewEntity() {
      const validationErrors = this.validateEntity();

      if (validationErrors.length) {
        this.alert.error = validationErrors[0];
        this.$refs.fadeAlertDanger.show();
        return;
      }

      this.entity.cityId = this.entity.address.municipioId;
      if (this.entity.companyName == "")
        this.entity.companyName = this.entity.fantasyName;
      if (!this.$route.params.edit) {
        this.$apiScheduler
          .post("/entity/create", this.entity)
          .then(response => {
            this.$refs.successFadeAlert.show();
          })
          .catch(error => {
            this.alert.error = error.response.data.split("-")[0];
            this.$refs.fadeAlertDanger.show();
          });

        this.entity = {
          id: null,
          active: true,
          companyId: null,
          company: null,
          createdAt: new Date().toISOString(),
          createdBy: null,
          createdByUser: null,
          updatedAt: new Date().toISOString(),
          updatedBy: null,
          updatedByUser: null,
          documentNumber: "",
          companyName: "",
          fantasyName: "",
          responsibleName: "",
          companyType: 1,
          parentDocumentNumber: "",
          taxRegime: null,
          specialTaxRegime: null,
          entityType: 0,
          stateRegistrationIndicator: null,
          stateRegistration: null,
          municipalRegistration: "",
          suframaRegistration: "",
          cityId: null,
          city: null,
          addressId: null,
          address: {
            id: null,
            logradouroId: null,
            logradouro: null,
            tipoLogradouroId: null,
            bairroId: null,
            municipioId: null,
            regiaoEstadoId: null,
            estadoId: null,
            regiaoPaisId: null,
            paisId: null,
            cep: "",
            numero: null,
            complemento: ""
          },
          isInternalGasStation: false,
          isExternalGasStation: false,
          isSupplier: false,
          isCustomer: false,
          isPurchaser: false,
          invoiceNFe: false,
          invoiceNFsE: false,
          invoiceNFcE: false,
          email: "",
          commercialPhone: "",
          mobilePhone: ""
        };
      } else {
        this.entity.createdByUser = null;
        this.entity.updatedByUser = null;
        this.$apiScheduler
          .post("/entity/edit", this.entity)
          .then(response => {
            alert("Empresa editada com sucesso!");
          })
          .catch(error => {
            alert(error);
          });
      }
    },
    async getAllCountries() {
      this.isLoadingCountry = true;
      try {
        const response = await this.$apiScheduler.get("/system/country");
        this.countryOptions = [...response.data];
      } catch (error) {
        console.error("Erro ao carregar países:", error);
      } finally {
        this.isLoadingCountry = false;
      }
    },
    async getAllStates(country) {
      this.isLoadingState = true;
      try {
        const response = await this.$apiScheduler.get(
          `/system/state/${country}`
        );
        this.stateOptions = [...response.data];
      } catch (error) {
        console.error("Erro ao carregar estados:", error);
      } finally {
        this.isLoadingState = false;
      }
    },

    async getAllCities(state) {
      this.isLoadingCity = true;
      try {
        const response = await this.$apiScheduler.get(`/system/city/${state}`);
        this.cityOptions = [...response.data];
      } catch (error) {
        console.error("Erro ao carregar municipios:", error);
      } finally {
        this.isLoadingCity = false;
      }
    },
    async getAllDistrict(city) {
      this.isLoadingDistrict = true;
      try {
        const response = await this.$apiScheduler.get(
          `/system/district/${city}`
        );
        this.districtOptions = [...response.data];
        this.districtOptions.push({ text: "Outro", value: "other" });
      } catch (error) {
        console.error("Erro ao carregar bairros:", error);
      } finally {
        this.isLoadingDistrict = false;
      }
    },

    async getAllStreets(district) {
      if (district != "other") {
        this.isLoadingStreet = true;
        try {
          const response = await this.$apiScheduler.get(
            `/system/street/${district}`
          );
          this.streetOptions = [...response.data];
          this.streetOptions.push({ text: "Outro", value: "other" });
        } catch (error) {
          console.error("Erro ao carregar ruas:", error);
        } finally {
          this.isLoadingStreet = false;
        }
      }
    },

    async getAllStreetTypes() {
      this.$apiScheduler
        .get("/system/streettype")
        .then(response => {
          this.streetTypeOptions = [...response.data];
        })
        .catch(error => {
          console.log(error);
        });
    },

    async addDistrict(district) {
      this.isLoadingDistrict = true;
      try {
        const response = await this.$apiScheduler.post(
          "/system/create/district",
          district
        );
        return response.data.bairro.id;
      } catch (error) {
        console.error("Erro ao adicionar bairro:", error);
        throw error;
      } finally {
        this.isLoadingDistrict = false;
      }
    },

    async addStreet(street) {
      this.isLoadingStreet = true;
      try {
        const response = await this.$apiScheduler.post(
          "/system/create/street",
          street
        );
        return response.data.logradouro;
      } catch (error) {
        console.error("Erro ao adicionar logradouro:", error);
        throw error;
      } finally {
        this.isLoadingStreet = false;
      }
    },

    getAddressByZipCode() {
      const cep = this.entity.address.cep.replace(/\D/g, "");
      if (!cep) return;

      fetch(`https://viacep.com.br/ws/${cep}/json/`)
        .then(response => response.json())
        .then(data => {
          this.entity.address.paisId = 1;
          this.getAllStates(this.entity.address.paisId).then(x => {
            if (data.estado) {
              const state = this.stateOptions.find(
                st => st.text == data.estado
              );
              this.entity.address.estadoId = state.value;

              this.getAllCities(state.value).then(x => {
                if (data.localidade) {
                  const city = this.cityOptions.find(
                    ct => ct.text == data.localidade
                  );

                  this.entity.address.municipioId = city.value;

                  this.getAllDistrict(city.value).then(x => {
                    if (data.bairro) {
                      var district = this.districtOptions.find(
                        ds => ds.text == data.bairro
                      );

                      if (!district) {
                        this.addDistrict({
                          municipioId: city.value,
                          nome: data.bairro
                        }).then(response => {
                          this.districtOptions.push({
                            text: data.bairro,
                            value: response
                          });
                          this.entity.address.bairroId = response;
                        });
                      } else {
                        this.entity.address.bairroId = district.value;
                      }

                      this.getAllStreets(district.value).then(x => {
                        if (data.logradouro) {
                          var logradouro = this.streetOptions.find(
                            ds => ds.text == data.logradouro
                          );
                          if (!logradouro) {
                            this.streetOptions.push({
                              text: data.logradouro,
                              value: "999999"
                            });
                            logradouro = { value: "999999" };
                          }
                          this.entity.address.logradouroId = logradouro.value;
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        })
        .catch(erro => {
          console.error("Erro ao buscar CEP:", erro);
        });
    },
    handleStreetTypeChange() {
      var selectedStreet = this.streetOptions.find(
        x => x.value == this.entity.address.logradouroId
      );
      if (selectedStreet.value == "other") {
        this.verifyNewStreet().then(response => {
          selectedStreet.value = response.id;
          this.entity.address.logradouroId = response.id;
        });
      }
    },
    verifyNewDistrict() {
      if (this.newDistrict != "" && this.newDistrict != null) {
        this.addDistrict({
          municipioId: this.entity.address.municipioId,
          nome: this.newDistrict
        }).then(response => {
          this.districtOptions.push({
            value: response,
            text: this.newDistrict
          });
          this.entity.address.bairroId = response;
        });
      }
    },
    async verifyNewStreet() {
      if (this.newStreet != "" && this.newStreet != null) {
        await this.addStreet({
          bairroId: this.entity.address.bairroId,
          nome: this.newStreet,
          tipoLogradouroId: this.entity.address.tipoLogradouroId
        }).then(response => {
          this.streetOptions.push({
            value: response,
            text: this.newStreet
          });
          this.entity.address.logradouroId = response;
        });
      }
    },
    validateEntity() {
      const errors = [];

      if (!this.entity.documentNumber || !this.entity.documentNumber.trim()) {
        errors.push("Por favor, insira um documento");
      }
      if (!this.entity.fantasyName || !this.entity.fantasyName.trim()) {
        errors.push("Por favor, insira o nome fantasia");
      }
      if (!this.entity.responsibleName || !this.entity.responsibleName.trim()) {
        errors.push("Por favor, insira o nome do responsável");
      }
      if (!this.entity.companyName || !this.entity.companyName.trim()) {
        errors.push("Por favor, insira a razão social");
      }

      if (this.entity.address.cep == null || this.entity.address.cep < 0) {
        errors.push("Por favor, insira um CEP.");
      }
      if (
        this.entity.address.paisId == null ||
        this.entity.address.paisId < 0
      ) {
        errors.push("Por favor, insira um Pais.");
      }
      if (
        this.entity.address.estadoId == null ||
        this.entity.address.estadoId < 0
      ) {
        errors.push("Por favor, insira um Estado.");
      }
      if (
        this.entity.address.municipioId == null ||
        this.entity.address.municipioId < 0
      ) {
        errors.push("Por favor, insira um Municipio.");
      }
      if (
        this.entity.address.bairroId == null ||
        this.entity.address.bairroId < 0
      ) {
        errors.push("Por favor, insira um Bairro.");
      }
      if (
        this.entity.address.logradouroId == null ||
        this.entity.address.logradouroId < 0
      ) {
        errors.push("Por favor, insira um Logradouro.");
      }
      if (
        this.entity.address.tipoLogradouroId == null ||
        this.entity.address.tipoLogradouroId < 0
      ) {
        errors.push("Por favor, insira um Tipo de Logradouro.");
      }
      if (
        this.entity.address.numero == null ||
        this.entity.address.numero < 0
      ) {
        errors.push("Por favor, insira um Número.");
      }

      return errors;
    },
    isValidCNPJ(cnpj) {
      var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
      var c = String(cnpj).replace(/[^\d]/g, "");

      if (c.length !== 14) return false;

      if (/0{14}/.test(c)) return false;

      for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]);
      if (c[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;

      for (var i = 0, n = 0; i <= 12; n += c[i] * b[i++]);
      if (c[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return false;

      return true;
    },

    isValidCPF(cpf) {
      cpf = cpf.replace(/[^\d]+/g, "");
      if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

      let soma = 0;
      for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i);
      let resto = (soma * 10) % 11;
      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== parseInt(cpf.charAt(9))) return false;

      soma = 0;
      for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i);
      resto = (soma * 10) % 11;
      if (resto === 10 || resto === 11) resto = 0;
      return resto === parseInt(cpf.charAt(10));
    },

    async validateDocumentNumber() {
      const document = this.entity.documentNumber.replace(/[^\d]/g, "");

      if (this.entity.entityType == "0") {
        const isValid = this.isValidCNPJ(document);
        this.documentNumberError = !isValid;

        if (isValid) {
          this.isLoadingCnpj = true;
          try {
            const response = await fetch(
              `https://publica.cnpj.ws/cnpj/${document}`
            );
            if (!response.ok) throw new Error("Erro ao consultar CNPJ");

            const data = await response.json();
            console.log("Dados do CNPJ:", data);

            this.entity.companyName = data.razao_social;
            this.entity.fantasyName = data.estabelecimento.nome_fantasia;
            this.entity.documentNumber = document;
            this.entity.address.cep = data.estabelecimento.cep;
            this.entity.email = data.estabelecimento.email;
            this.entity.address.numero = data.estabelecimento.numero;
            this.entity.commercialPhone = data.estabelecimento.telefone1;
            this.entity.mobilePhone = data.estabelecimento.telefone2;
            this.entity.companyType =
              data.estabelecimento.tipo == "Matriz" ? 1 : 2;
            this.isLoadingCnpj = false;
          } catch (error) {
            this.isLoadingCnpj = false;
            console.error("Erro ao buscar dados do CNPJ:", error);
          }
        }
      } else if (this.entity.entityType == "1") {
        const isValid = this.isValidCPF(document);
        this.documentNumberError = !isValid;
        if (isValid) {
          this.entity.documentNumber = document;
        }
      } else {
        this.documentNumberError = false;
      }
    }
  }
};
</script>
<style></style>
